import { Grid, MenuItem } from "@material-ui/core";
import { IUsageType } from "./interface/IUsageType";
import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";
import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import { IFetchState } from "src/itsf/fetch/fetcherUtils";

interface IParams {
    selectedTimePeriod: string;
    selectedType: string;
    getUsageTypeListState: IFetchState;
    usageTypeList: IUsageType[];
    timeFilterOptions: { label: string; value: string }[];
    getUsageTypeList(): void;
    onTimePeriodChange(newTimePeriod: string): void;
    onSelectedTypeChange(selectedType: string): void;
}

export const UsageFilter = (props: IParams) => {
    const {
        selectedTimePeriod,
        selectedType,
        getUsageTypeListState,
        usageTypeList,
        onTimePeriodChange,
        onSelectedTypeChange,
        getUsageTypeList,
        timeFilterOptions,
    } = props;
    const { t } = useTranslation("usage");

    return (
        <Grid container justify="center" spacing={5}>
            <Grid item md={3} xs={6}>
                <Select
                    aria-label="Time period select"
                    disableUnderline
                    displayEmpty
                    fullWidth
                    id="selected-time-period"
                    label={t("timePeriod")}
                    value={selectedTimePeriod}
                    variant="filled"
                    onChange={(event) => onTimePeriodChange(event.target.value as string)}
                >
                    {timeFilterOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </Grid>
            <Grid item md={3} xs={6}>
                <HandleErrorAndLoading
                    error={getUsageTypeListState.error}
                    isLoading={getUsageTypeListState.isLoading}
                    retryFetch={getUsageTypeList}
                >
                    <Select
                        aria-label="Usage type select"
                        disableUnderline
                        displayEmpty
                        fullWidth
                        id="selected-type"
                        value={selectedType}
                        variant="filled"
                        onChange={(event) => onSelectedTypeChange(event.target.value as string)}
                    >
                        <MenuItem key={t("all")} value={t("all")}>
                            {t("all")}
                        </MenuItem>
                        {usageTypeList.map(({ key, name }) => (
                            <MenuItem aria-label="usage type option" key={key} value={key}>
                                {t(name as any)}
                            </MenuItem>
                        ))}
                    </Select>
                </HandleErrorAndLoading>
            </Grid>
        </Grid>
    );
};
